import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
export function useUncontrolled(initialValue, onChange) {
  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleValueChange = useCallback(function (_ref) {
    var value = _ref.target.value;
    setValue(value);
    onChange({
      target: {
        value: value
      }
    });
  }, [onChange]);
  return [value, handleValueChange];
}